import {ApiService, GetListResponse, ModelBase} from '@app/api/api.service';
import {Injectable} from '@angular/core';


export interface SoftwareImage extends ModelBase {
    version_name: string;
    s3_url: string;
    openlab_version?: string;
}

interface GetImagesListResponse extends GetListResponse {
    software_images: Array<SoftwareImage>;
}

interface GetImagesArguments {
    offset: number;
    limit: number;
    image_type: string;
}

export interface SoftwareList {
    aicImages: {
        [propName: string]: any;
    }[];
    acImages: {}[];
    windowsUpdates: {
        [propName: string]: any;
    }[];
    drivers: {
        [propName: string]: any;
    }[];
}

export interface SoftwareVersionsObject {
    aicImageId: number;
    acImageId: number;
    windowsUpdateId: number;
    driverIds: {
        [propName: string]: any; // additional parameters
    };
}

@Injectable({
    providedIn: 'root'
})
export class SoftwareImagesApi {

    constructor(private apiService: ApiService) {
    }

    async getSoftwareVersionReleaseNotesUrl(softwareId, versionId) {
        return this.apiService.getResponseJson({
            urlPart: `/software-images/${softwareId}/${versionId}/release-notes`
        });
    }

    async getSoftwareFile(softwareId, versionId) {
        return this.apiService.getResponseJson({
            urlPart: `/software-images/${softwareId}/${versionId}`
        });
    }

    async getSoftwareChecksum(softwareId, versionId) {
        return this.apiService.getResponseJson({
            urlPart: `/software-images/${softwareId}/${versionId}/checksum`
        });
    }

    async getSoftware() {
        return this.apiService.getResponseJson({
            urlPart: '/software'
        });
    }
}
